import React, { useState, useEffect } from "react";
import { Form, Modal } from "react-bootstrap";
import ModalFooter from "./UserPageForms/ModalFooter";
import { allBundles } from "../Util/Constants";
import { allItaasBundles } from "../Util/Constants";
import { allAsanaBundles } from "../Util/Constants";
import { allCopilotBundles } from "../Util/Constants";
import { allAdobeAcrobatProBundles } from "../Util/Constants";
import { allTeamsPhoneBundles } from "../Util/Constants";

const QuickAddUserModal = (props) => {
  const [newUser, setNewUser] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(false);
  }, [props.show]);

  const updateUser = (nameOfField, value) => {
    setNewUser({ ...newUser, [nameOfField]: value });
  };

  const updateBusinessUnit = (value) => {
    let companyName = props.businessUnits.find((x) => x.businessUnitName === value).bcCompanyName;
    setNewUser({ ...newUser, companyName: companyName });
  };

  useEffect(() => {
    if (!props.businessUnits) {
      return;
    }

    const sortedBusinessUnits = [...props.businessUnits].sort((x, y) =>
      x.businessUnitName.toString().toLowerCase().localeCompare(y.businessUnitName)
    );

    setNewUser({
      fullName: "",
      domainName: "",
      companyName: sortedBusinessUnits[0].businessUnitName,
      bundle: allBundles[0],
      itaasBundle: "None",
      asanaBundle: "None",
      copilotBundle: "None",
      adobeAcrobatProBundle: "None",
      teamsPhoneBundle: "None",
    });
  }, [props.show, props.businessUnits]);

  return (
    <Modal show={props.show} onHide={props.onHide} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Quick Add User</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <div style={{ display: "flex", justifyContent: "space-between", gap: "20px" }}>
            <Form.Group className="mb-3 w-50" controlId="userFullName">
              <Form.Label>
                <b>Full Name</b>
              </Form.Label>
              <Form.Control
                as="input"
                placeholder="Enter User Full Name"
                custom
                onChange={(value) => updateUser("fullName", value.target.value)}
              ></Form.Control>
            </Form.Group>
            <Form.Group className="mb-3 w-50" controlId="userDomainName">
              <Form.Label>
                <b>Domain Name</b>
              </Form.Label>
              <Form.Control
                as="input"
                placeholder="Enter User Domain Name"
                custom
                onChange={(value) => updateUser("domainName", value.target.value)}
              ></Form.Control>
            </Form.Group>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", gap: "20px" }}>
            <Form.Group className="mb-3 w-50" controlId="userBusinessUnit">
              <Form.Label>
                <b>Company</b>
              </Form.Label>
              <Form.Select
                placeholder="Enter User Business Unit"
                custom
                onChange={(value) => updateBusinessUnit(value.target.value)}
              >
                {props.businessUnits &&
                  props.businessUnits
                    .sort((x, y) => x.businessUnitName.toString().toLowerCase().localeCompare(y.businessUnitName))
                    .map((businessUnit) => {
                      return <option key={businessUnit.businessUnitGuid}>{businessUnit.businessUnitName}</option>;
                    })}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3 w-50" controlId="userBundle">
              <Form.Label>
                <b>Bundle</b>
              </Form.Label>
              <Form.Select
                placeholder="Enter User Bundle"
                custom
                onChange={(value) => updateUser("bundle", value.target.value)}
              >
                {allBundles.map((bundle) => {
                  return <option key={bundle}>{bundle}</option>;
                })}
              </Form.Select>
            </Form.Group>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", gap: "20px" }}>
            <Form.Group className="mb-3 w-50" controlId="userITaaSLevel">
              <Form.Label>
                <b>ITaaS Bundle</b>
              </Form.Label>
              <Form.Select
                placeholder="Enter ITaaS Level"
                custom
                onChange={(value) => updateUser("itaasBundle", value.target.value)}
              >
                {allItaasBundles.map((bundle) => {
                  return <option key={bundle}>{bundle}</option>;
                })}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3 w-50" controlId="updateUserSelect">
              <Form.Label>
                <b>Asana Bundle</b>
              </Form.Label>
              <Form.Select custom onChange={(value) => updateUser("asanaBundle", value.target.value)}>
                {allAsanaBundles.map((bundle) => {
                  return <option key={bundle}>{bundle}</option>;
                })}
              </Form.Select>
            </Form.Group>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", gap: "20px" }}>
            <Form.Group className="mb-3 w-50" controlId="updateUserSelect">
              <Form.Label>
                <b>Copilot Bundle</b>
              </Form.Label>
              <Form.Select custom onChange={(value) => updateUser("copilotBundle", value.target.value)}>
                {allCopilotBundles.map((bundle) => {
                  return <option key={bundle}>{bundle}</option>;
                })}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3 w-50" controlId="updateUserSelect">
              <Form.Label>
                <b>Adobe Acrobat Pro Bundle</b>
              </Form.Label>
              <Form.Select custom onChange={(value) => updateUser("adobeAcrobatProBundle", value.target.value)}>
                {allAdobeAcrobatProBundles.map((bundle) => {
                  return <option key={bundle}>{bundle}</option>;
                })}
              </Form.Select>
            </Form.Group>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", gap: "20px" }}>
            <Form.Group className="mb-3 w-50" controlId="updateUserSelect">
              <Form.Label>
                <b>Teams Phone Bundle</b>
              </Form.Label>
              <Form.Select custom onChange={(value) => updateUser("teamsPhoneBundle", value.target.value)}>
                {allTeamsPhoneBundles.map((bundle) => {
                  return <option key={bundle}>{bundle}</option>;
                })}
              </Form.Select>
            </Form.Group>
          </div>
        </Form>
      </Modal.Body>
      <ModalFooter
        mode="quickAdd"
        onSubmitClick={() => {
          setIsLoading(true);
          props.onAdd(newUser);
        }}
        submitLoading={isLoading}
        onHide={props.onHide}
        submitButtonText="Add"
      />
    </Modal>
  );
};

export default QuickAddUserModal;
